// 合并开票
import api from '@/api'

const state = {

}

const mutations = {

}

const actions = {
  // 获取配置开关
  getInvoiceSwitch ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getInvoiceSwitch(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/advanceInvoice/switch', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/advanceInvoice/switch', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 发票识别
  getRecognize ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getRecognize(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/advanceInvoice/recognize', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/advanceInvoice/recognize', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 物流信息列表
  getDeliveryList ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getDeliveryList(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/advanceInvoice/getDeliveryList', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/advanceInvoice/getDeliveryList', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 提交物流信息
  submitDelivery ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.submitDelivery(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/advanceInvoice/submitDelivery', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/advanceInvoice/submitDelivery', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 融合平台列表查询
  asmInvoiceList ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.asmInvoiceList(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/advanceInvoice/asmInvoiceList', error: res.error })
        }
      }).catch(e => {
        reject({from: '/sweb/advanceInvoice/asmInvoiceList', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 融合平台快递单保存(即发票提交)
  submitAsmDelivery ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.submitAsmDelivery(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/advanceInvoice/submitAsmDelivery', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/advanceInvoice/submitAsmDelivery', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  },
  // 融合平台保存图片链接
  submitAsmImage ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.submitAsmImage(data).then(res => {
        let resData = res.data
        if (resData.ret === 1) {
          resolve(resData)
        } else {
          reject({ from: '/sweb/advanceInvoice/submitImage', error: resData.error })
        }
      }).catch(e => {
        reject({from: '/sweb/advanceInvoice/submitImage', error: {code: 0, msg: '网络异常，请稍后再试'}})
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/paperInvoice.js